import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 *活动列表
 * @param params
 * 
*/

export const activityList = params => Http.get(`${baseUrl}/activity`, { params })

/**
 *查看活动详情
 * @param activityId
 * 
*/

export const activityInfo = activityId => Http.get(`${baseUrl}/activity/${activityId}`)
